
import { defineComponent, onMounted } from 'vue'
import LayoutAuthSidebar from '@/components/LayoutAuthSidebar.vue'
import LayoutAuthPcHeader from '@/components/LayoutAuthPcHeader.vue'
import LayoutAuthMobileHeader from '@/components/LayoutAuthMobileHeader.vue'
import LayoutAuthMobileFooter from '@/components/LayoutAuthMobileFooter.vue'
import LayoutAuthContentsFooter from '@/components/LayoutAuthContentsFooter.vue'
import BaseBackIcon from '@/components/BaseBackIcon.vue'
import { useStore } from '@/store/index'
import LayoutsAuthWidth from '@/layouts/AuthWidth.vue'
import searchHistory from '@/components/SearchHistory.vue'

export default defineComponent({
  components: {
    LayoutAuthSidebar,
    LayoutAuthPcHeader,
    LayoutAuthMobileHeader,
    LayoutAuthMobileFooter,
    LayoutAuthContentsFooter,
    BaseBackIcon,
    LayoutsAuthWidth,
    searchHistory
  },
  setup() {
    const store = useStore()

    onMounted(() => {
      // Authの全画面共通でAPI叩く
      Promise.allSettled([
        store.dispatch('menu/fetchMenuCategories')
      ])
    })

    return {
      store,
    }
  },
})
